/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
	module.exports = require('./browser.js');
} else {
	module.exports = require('./node.js');
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-external-compile/~/debug/src/index.js
// module id = 2772
// module chunks = 0 1